export default __webpack_public_path__ + "static/media/Directors' Certificate to Ms Annaliza H Lumanglas ( Bauan Branch ).175c0264.pdf";